
















import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import { SerializedAspectValueDescriptor } from '@xlearn/common';
import Debug from 'debug'

const debug = Debug('aspect-tiles-component')

@Component
export default class AspectTilesComponent extends Vue {
  @Prop()
  public values: SerializedAspectValueDescriptor[];

  @Prop()
  public containerCssClass: string;

  public selectedId: string|null = null;

  @Emit('selected')
  public emitSelected(id: string): string {
    this.selectedId = id;
    debug('selectedId: ', this.selectedId)
    return id;
  }
}
